import { motion } from "framer-motion";
import { Reveal } from "../Reveal";
import Counter from "../Counter";
import { STATS, CONTACT } from "../../lib/data";

const ABOUT_IMG = "https://images.unsplash.com/photo-1487754180451-c456f719a1fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative overflow-hidden bg-ink py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <Reveal>
              <span className="text-xs font-bold uppercase tracking-[0.3em] text-gold">Our Story</span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 font-display text-4xl font-medium leading-tight tracking-tight sm:text-5xl lg:text-6xl">
                Oil changes,<br /> reimagined for <span className="text-gradient-gold">your time.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 max-w-xl text-base leading-relaxed text-white/60 md:text-lg">
                Luigi Lube was built on one simple idea: your time is too valuable to spend
                in a waiting room. We bring a fully-equipped mobile service directly to your
                driveway, office or job site in {CONTACT.area} — and treat every vehicle like
                it's our own.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <p className="mt-5 max-w-xl text-base leading-relaxed text-white/60 md:text-lg">
                Punctual, prepared and professional — it's why our customers keep coming back
                and why we've earned a perfect {CONTACT.rating}-star rating.
              </p>
            </Reveal>

            <div className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-ink-soft bg-ink-soft sm:grid-cols-4">
              {STATS.map((s, i) => (
                <Reveal key={i} delay={0.1 * i} className="bg-ink p-6">
                  <div className="font-display text-3xl font-semibold text-gold md:text-4xl" data-testid={`stat-${i}`}>
                    <Counter value={s.value} suffix={s.suffix} decimals={s.decimals || 0} />
                  </div>
                  <div className="mt-2 text-xs leading-snug text-white/50">{s.label}</div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={0.2} className="relative h-full">
              <motion.div
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.5 }}
                className="relative h-80 overflow-hidden rounded-3xl border border-white/5 lg:h-full"
              >
                <img src={ABOUT_IMG} alt="Mobile oil service" className="h-full w-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/20 to-transparent" />
                <div className="absolute bottom-6 left-6 right-6 glass rounded-2xl p-5">
                  <p className="font-display text-lg font-medium text-white">Fully mobile. Fully prepared.</p>
                  <p className="mt-1 text-sm text-white/60">Serving {CONTACT.area} & surrounding area.</p>
                </div>
              </motion.div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
